// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__GqoRH","check":"style_check__83IHS","label":"style_label__PHtUS"};